import { Router } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(event) {
  //   if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
  //     document.getElementById("navbar").style.background = "rgba(51, 51, 51, 0.767)";
  //   } else {
  //     document.getElementById("navbar").style.background = "transparent";
  //   }
  // }

  navigateTo(url: string){
    this.router.navigateByUrl(url);
  }
}
